import { useState, useEffect } from 'react';
import { toast } from 'sonner';
import { api, API } from '../App';
import { Eye, Star, X, ChevronLeft, ChevronRight, MapPin, Building2, User, Phone, Calendar } from 'lucide-react';

function Stars({ puan }) {
  const p = Math.round(puan || 0);
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 2 }}>
      {[1,2,3,4,5].map(s => (
        <span key={s} style={{ color: s <= p ? '#fbbf24' : '#e2e8f0', fontSize: 16 }}>★</span>
      ))}
      <span style={{ fontSize: 12, color: 'var(--gray-400)', marginLeft: 4 }}>
        {puan ? Number(puan).toFixed(1) : '—'}
      </span>
    </span>
  );
}

export default function AnketSonuclar() {
  const [sonuclar, setSonuclar] = useState([]);
  const [toplam, setToplam] = useState(0);
  const [lokasyonlar, setLokasyonlar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [detay, setDetay] = useState(null);
  const [sayfa, setSayfa] = useState(1);
  const limit = 20;

  const [filtre, setFiltre] = useState({
    lokasyon_id: '',
    baslangic: '',
    bitis: '',
  });

  const load = async (page = sayfa) => {
    setLoading(true);
    try {
      const params = { sayfa: page, limit, ...filtre };
      const { data } = await api.get('/anketler/sonuclar/liste', { params });
      setSonuclar(data.sonuclar);
      setToplam(data.toplam);
    } catch { toast.error('Yüklenemedi'); }
    finally { setLoading(false); }
  };

  const loadLokasyonlar = async () => {
    try { const { data } = await api.get('/lokasyonlar'); setLokasyonlar(data); } catch {}
  };

  useEffect(() => { loadLokasyonlar(); }, []);
  useEffect(() => { load(sayfa); }, [sayfa]);

  const handleSearch = e => {
    e.preventDefault();
    setSayfa(1);
    load(1);
  };

  const openDetay = async (id) => {
    try {
      const { data } = await api.get(`/anketler/sonuclar/${id}`);
      setDetay(data);
    } catch { toast.error('Detay yüklenemedi'); }
  };

  const sayfaSayisi = Math.ceil(toplam / limit);

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Anket Sonuçları</h1>
          <p className="page-subtitle">Toplam {toplam} anket</p>
        </div>
      </div>

      {/* Filtreler */}
      <form onSubmit={handleSearch} className="card filter-card" style={{ padding: 16, marginBottom: 20 }}>
        <div className="input-group input-group-wide">
          <label className="input-label">Lokasyon</label>
          <select className="input" value={filtre.lokasyon_id} onChange={e => setFiltre({ ...filtre, lokasyon_id: e.target.value })}>
            <option value="">Tümü</option>
            {lokasyonlar.map(l => <option key={l.id} value={l.id}>{l.ad} {l.bina_adi ? `(${l.bina_adi})` : ''}</option>)}
          </select>
        </div>
        <div className="input-group">
          <label className="input-label">Başlangıç</label>
          <input className="input" type="date" value={filtre.baslangic} onChange={e => setFiltre({ ...filtre, baslangic: e.target.value })} />
        </div>
        <div className="input-group">
          <label className="input-label">Bitiş</label>
          <input className="input" type="date" value={filtre.bitis} onChange={e => setFiltre({ ...filtre, bitis: e.target.value })} />
        </div>
        <button type="submit" className="btn btn-primary">Filtrele</button>
        <button type="button" className="btn btn-secondary" onClick={() => { setFiltre({ lokasyon_id: '', baslangic: '', bitis: '' }); setSayfa(1); setTimeout(() => load(1), 0); }}>Temizle</button>
      </form>

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 60 }}>
          <div className="spinner spinner-blue" style={{ width: 32, height: 32 }} />
        </div>
      ) : (
        <>
          <div className="card">
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Katılımcı</th>
                    <th>Lokasyon</th>
                    <th>Bina</th>
                    <th>Puan</th>
                    <th>Tarih</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {sonuclar.map(s => (
                    <tr key={s.id}>
                      <td>
                        <div style={{ fontWeight: 500 }}>{s.ad || 'Anonim'}</div>
                        {s.telefon && <div style={{ fontSize: 12, color: 'var(--gray-400)' }}>{s.telefon}</div>}
                      </td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                          <MapPin size={13} color="var(--blue)" />
                          {s.lokasyon_adi}
                        </div>
                      </td>
                      <td style={{ fontSize: 13, color: 'var(--gray-600)' }}>{s.bina_adi || '—'}</td>
                      <td>
                        {s.genel_puan
                          ? <span className={`badge ${s.genel_puan >= 4 ? 'badge-green' : s.genel_puan >= 3 ? 'badge-yellow' : 'badge-red'}`}>
                              {'★'.repeat(Math.round(s.genel_puan))} {Number(s.genel_puan).toFixed(1)}
                            </span>
                          : <span style={{ color: 'var(--gray-400)', fontSize: 13 }}>—</span>
                        }
                      </td>
                      <td style={{ fontSize: 13, color: 'var(--gray-600)' }}>
                        {new Date(s.olusturma_tarihi).toLocaleString('tr-TR')}
                      </td>
                      <td>
                        <button className="btn btn-secondary btn-sm btn-icon" onClick={() => openDetay(s.id)} title="Detay">
                          <Eye size={14} />
                        </button>
                      </td>
                    </tr>
                  ))}
                  {!sonuclar.length && (
                    <tr><td colSpan={6} style={{ textAlign: 'center', padding: 40, color: 'var(--gray-400)' }}>Sonuç bulunamadı</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {/* Sayfalama */}
          {sayfaSayisi > 1 && (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12, marginTop: 20 }}>
              <button className="btn btn-secondary btn-sm" disabled={sayfa <= 1} onClick={() => setSayfa(s => s - 1)}>
                <ChevronLeft size={15} /> Önceki
              </button>
              <span style={{ fontSize: 14, color: 'var(--gray-600)' }}>
                {sayfa} / {sayfaSayisi}
              </span>
              <button className="btn btn-secondary btn-sm" disabled={sayfa >= sayfaSayisi} onClick={() => setSayfa(s => s + 1)}>
                Sonraki <ChevronRight size={15} />
              </button>
            </div>
          )}
        </>
      )}

      {/* Detay Modal */}
      {detay && (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && setDetay(null)}>
          <div className="modal modal-lg">
            <div className="modal-header">
              <div>
                <span className="modal-title">Anket Detayı</span>
                <div style={{ fontSize: 12, color: 'var(--gray-400)', marginTop: 2 }}>
                  #{detay.oturum?.id} · {new Date(detay.oturum?.olusturma_tarihi).toLocaleString('tr-TR')}
                </div>
              </div>
              <button className="btn btn-ghost btn-icon btn-sm" onClick={() => setDetay(null)}><X size={16} /></button>
            </div>
            <div className="modal-body">
              {/* Özet bilgi */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 20 }}>
                {[
                  { icon: User, label: 'Katılımcı', val: detay.oturum?.ad || 'Anonim' },
                  { icon: Phone, label: 'Telefon', val: detay.oturum?.telefon || '—' },
                  { icon: MapPin, label: 'Lokasyon', val: detay.oturum?.lokasyon_adi },
                  { icon: Building2, label: 'Bina', val: detay.oturum?.bina_adi || '—' },
                ].map(({ icon: Icon, label, val }) => (
                  <div key={label} style={{ padding: '12px 14px', background: 'var(--gray-50)', borderRadius: 10, border: '1px solid var(--gray-100)' }}>
                    <div style={{ fontSize: 11, fontWeight: 600, color: 'var(--gray-400)', textTransform: 'uppercase', marginBottom: 4 }}>{label}</div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 14, fontWeight: 500 }}><Icon size={13} color="var(--blue)" />{val}</div>
                  </div>
                ))}
              </div>

              <div style={{ textAlign: 'center', marginBottom: 20, padding: 16, background: '#fffbeb', borderRadius: 12, border: '1px solid #fef08a' }}>
                <div style={{ fontSize: 12, color: '#854d0e', marginBottom: 6 }}>Genel Puan</div>
                <Stars puan={detay.oturum?.genel_puan} />
              </div>

              {/* Cevaplar */}
              <h4 style={{ fontSize: 14, fontWeight: 700, marginBottom: 12 }}>Cevaplar</h4>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {detay.cevaplar?.map(c => (
                  <div key={c.id} style={{ padding: '12px 14px', background: 'var(--gray-50)', borderRadius: 10, border: '1px solid var(--gray-100)' }}>
                    <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6, color: 'var(--navy)' }}>{c.soru_metni}</div>
                    {c.soru_tipi === 'yildiz' && c.yildiz_degeri && <Stars puan={c.yildiz_degeri} />}
                    {c.soru_tipi === 'evet_hayir' && c.evet_hayir !== null && (
                      <span className={`badge ${c.evet_hayir ? 'badge-green' : 'badge-red'}`}>{c.evet_hayir ? '✓ Evet' : '✗ Hayır'}</span>
                    )}
                    {c.soru_tipi === 'acik_metin' && c.acik_metin && (
                      <p style={{ fontSize: 13, color: 'var(--gray-600)', margin: 0 }}>{c.acik_metin}</p>
                    )}
                  </div>
                ))}
              </div>

              {/* Fotoğraflar */}
              {detay.fotograflar?.length > 0 && (
                <div style={{ marginTop: 16 }}>
                  <h4 style={{ fontSize: 14, fontWeight: 700, marginBottom: 10 }}>Fotoğraflar</h4>
                  <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                    {detay.fotograflar.map(f => (
                      <a key={f.id} href={`${API.replace('/api','')}/uploads/anket/${f.dosya_yolu}`} target="_blank" rel="noreferrer">
                        <img src={`${API.replace('/api','')}/uploads/anket/${f.dosya_yolu}`} alt="" style={{ width: 80, height: 80, borderRadius: 10, objectFit: 'cover', border: '1px solid var(--gray-100)' }} />
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
